// ✅ Import all API services
import BaseApiService from './BaseApiService.js';
import AuthService from './AuthService.js';
import StudentService from './StudentService.js';
import TeacherService from './TeacherService.js';
import DepartmentService from './DepartmentService.js';
import CourseService from './CourseService.js';
import ClassService from './ClassService.js';
import SubjectService from './SubjectService.js';
import SubjectAssignmentService from './SubjectAssignmentService.js';
import FeeService from './FeeService.js';
import TimetableService from './TimetableService.js';
import FeeReminderService from './FeeReminderService.js';
import HostelService from './HostelService.js';
import VehicleService from './VehicleService.js';
import SmartAlertService from './SmartAlertService.js';
import BrandingService from './BrandingService.js';
import ReportCardService from './ReportCardService.js';
import ReportCardTemplateService from './ReportCardTemplateService.js';
import LibraryService from './LibraryService.js';
import StudentBusService from './StudentBusService.js';
import SubUserService from './SubUserService.js';
import HomeworkService from './HomeworkService.js';
import AcademicSectionService from './AcademicSectionService.js';


// ✅ Export all services for easy importing
export {
  BaseApiService,
  AuthService,
  StudentService,
  TeacherService,
  DepartmentService,
  CourseService,
  ClassService,
  SubjectService,
  SubjectAssignmentService,
  FeeService,
  TimetableService,
  FeeReminderService,
  HostelService,
  VehicleService,
  SmartAlertService,
  BrandingService,
  ReportCardService,
  ReportCardTemplateService,
  LibraryService,
  StudentBusService,
  SubUserService,
  HomeworkService,
  AcademicSectionService
};

// ✅ Export default services (instances)
const services = {
  auth: AuthService,
  student: StudentService,
  teacher: TeacherService,
  department: DepartmentService,
  course: CourseService,
  class: ClassService,
  subject: SubjectService,
  subjectAssignment: SubjectAssignmentService,
  fee: FeeService,
  timetable: TimetableService,
  feeReminder: FeeReminderService,
  hostel: HostelService,
  vehicle: VehicleService,
  smartAlert: SmartAlertService,
  branding: BrandingService,
  reportCard: ReportCardService,
  library: LibraryService,
  studentBus: StudentBusService,
  subUser: SubUserService,
  homework: HomeworkService,
  academicSection: AcademicSectionService
};

export default services;

// ✅ Individual service exports for convenience
export { default as authService } from './AuthService.js';
export { default as studentService } from './StudentService.js';
export { default as teacherService } from './TeacherService.js';
export { default as departmentService } from './DepartmentService.js';
export { default as courseService } from './CourseService.js';
export { default as classService } from './ClassService.js';
export { default as subjectService } from './SubjectService.js';
export { default as subjectAssignmentService } from './SubjectAssignmentService.js';
export { default as feeService } from './FeeService.js';
export { default as timetableService } from './TimetableService.js';
export { default as feeReminderService } from './FeeReminderService.js';
export { default as hostelService } from './HostelService.js';
export { default as vehicleService } from './VehicleService.js';
export { default as smartAlertService } from './SmartAlertService.js';
export { default as brandingService } from './BrandingService.js';
export { default as reportCardService } from './ReportCardService.js';
export { default as reportCardTemplateService } from './ReportCardTemplateService.js';
export { default as libraryService } from './LibraryService.js';
export { default as studentBusService } from './StudentBusService.js';
export { default as subUserService } from './SubUserService.js';
export { default as dashboardService } from './DashboardService.js';
export { default as homeworkService } from './HomeworkService.js';
export { default as academicSectionService } from './AcademicSectionService.js';

